import { useEffect, useState } from "react";
var useDebounce = function useDebounce(value) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var _useState = useState(value),
    debouncedValue = _useState[0],
    setDebouncedValue = _useState[1];
  useEffect(function () {
    var id = setTimeout(function () {
      setDebouncedValue(value);
    }, delay);
    return function () {
      clearTimeout(id);
    };
  }, [value, delay]);
  return debouncedValue;
};
export default useDebounce;